import { DateTypeNames } from '../@types/attendanceReport.type';
import { ColumnSelectionItem } from '../components/templates/ColumnSelection';

export const AUTOCOMPLET_DROPDOWN_ITEMS = {
  label: '',
  value: ''
};

export const MONTHS_OF_YEAR = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export const DAYS_OF_WEEK = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const RAW_DATE_RANGES = [
  { label: 'Now', value: 'now' },
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'first day of this week', value: DateTypeNames.First_Day_Of_This_Week },
  { label: 'first day of this month', value: DateTypeNames.First_Day_Of_This_Month },
  { label: 'first day of this year', value: DateTypeNames.First_Day_Of_This_Year },
  { label: 'last day of this week', value: DateTypeNames.Last_Day_Of_This_Week },
  { label: 'last day of this month', value: DateTypeNames.Last_Day_Of_This_Month },
  { label: 'last day of this year', value: DateTypeNames.Last_Day_Of_This_Year },
  { label: 'first day of last week', value: DateTypeNames.First_Day_Of_Last_Week },
  { label: 'first day of last month', value: DateTypeNames.First_Day_Of_Last_Month },
  { label: 'first day of last year', value: DateTypeNames.First_Day_Of_Last_Year },
  { label: 'last day of last week', value: DateTypeNames.Last_Day_Of_Last_Week },
  { label: 'last day of last month', value: DateTypeNames.Last_Day_Of_Last_Month },
  { label: 'last day of last year', value: DateTypeNames.Last_Day_Of_Last_Year }
];

export const attendanceColumnSelectionItems: Array<ColumnSelectionItem> = [
  {
    title: 'Attendance Report',
    value: [
      {
        title: 'Service ID',
        field: 'serviceId',
        value: true
      },
      {
        title: 'Attendance ID',
        field: 'attendanceId',
        value: true
      },
      {
        title: 'Service Type',
        field: 'serviceType',
        value: false
      },
      {
        title: 'Service Action Type',
        field: 'serviceActionType',
        value: false
      },
      {
        title: 'Service Process Type',
        field: 'serviceProcessType',
        value: false
      },
      {
        title: 'Client/Contract',
        field: 'clientContract',
        value: true
      },
      {
        title: 'Service Location',
        field: 'serviceLocation',
        value: true
      },
      {
        title: 'User',
        field: 'siblingNodeName',
        value: true
      },
      {
        title: 'Parent',
        field: 'parentNodeName',
        value: true
      },
      {
        title: 'Reported CheckIn DateTime',
        field: 'reportedCheckInDateTime',
        value: true
      },
      {
        title: 'Reported CheckOut DateTime',
        field: 'reportedCheckOutDateTime',
        value: true
      },
      {
        title: 'On-Site Time',
        field: 'onSiteTime',
        value: true
      },
      {
        title: 'CheckOut Status',
        field: 'checkOutStatus',
        value: true
      },
      {
        title: 'Actual CheckIn TimeStamp',
        field: 'actualCheckInTimeStamp',
        value: false
      },
      {
        title: 'Actual CheckOut TimeStamp',
        field: 'actualCheckOutTimeStamp',
        value: false
      },
      {
        title: 'Service Location Suburb',
        field: 'serviceLocationSuburb',
        value: false
      },
      {
        title: 'Service Location State',
        field: 'serviceLocationState',
        value: false
      },
      {
        title: 'Service Location Postcode',
        field: 'serviceLocationPostcode',
        value: false
      },
    ]
  }
];

export const RELATIVE_DATE_RANGES = [
  { label: 'today', value: 'today' },
  { label: 'yesterday', value: 'yesterday' },
  { label: 'first day of this month', value: 'first-day-of-this-month' },
  { label: 'first day of this year', value: 'first-day-of-this-year' },
  { label: 'last day of this month', value: 'last-day-of-this-month' },
  { label: 'last day of this year', value: 'last-day-of-this-year' },
  { label: 'first day of last month', value: 'first-day-of-last-month' },
  { label: 'first day of last year', value: 'first-day-of-last-year' },
  { label: 'last day of last month', value: 'last-day-of-last-month' },
  { label: 'last day of last year', value: 'last-day-of-last-year' },
  { label: 'Monday this week', value: 'monday-this-week' },
  { label: 'Tuesday this week', value: 'tuesday-this-week' },
  { label: 'Wednesday this week', value: 'wednesday-this-week' },
  { label: 'Thursday this week', value: 'thursday-this-week' },
  { label: 'Friday this week', value: 'friday-this-week' },
  { label: 'Saturday this week', value: 'saturday-this-week' },
  { label: 'Sunday this week', value: 'sunday-this-week' },
  { label: 'Monday last week', value: 'monday-last-week' },
  { label: 'Tuesday last week', value: 'tuesday-last-week' },
  { label: 'Wednesday last week', value: 'wednesday-last-week' },
  { label: 'Thursday last week', value: 'thursday-last-week' },
  { label: 'Friday last week', value: 'friday-last-week' },
  { label: 'Saturday last week', value: 'saturday-last-week' },
  { label: 'Sunday last week', value: 'sunday-last-week' },
  { label: 'first day of January this year', value: 'first-day-of-january-this-year' },
  { label: 'first day of February this year', value: 'first-day-of-february-this-year' },
  { label: 'first day of March this year', value: 'first-day-of-march-this-year' },
  { label: 'first day of April this year', value: 'first-day-of-april-this-year' },
  { label: 'first day of May this year', value: 'first-day-of-may-this-year' },
  { label: 'first day of June this year', value: 'first-day-of-june-this-year' },
  { label: 'first day of July this year', value: 'first-day-of-july-this-year' },
  { label: 'first day of August this year', value: 'first-day-of-august-this-year' },
  { label: 'first day of September this year', value: 'first-day-of-september-this-year' },
  { label: 'first day of October this year', value: 'first-day-of-october-this-year' },
  { label: 'first day of November this year', value: 'first-day-of-november-this-year' },
  { label: 'first day of December this year', value: 'first-day-of-december-this-year' },
  { label: 'first day of January last year', value: 'first-day-of-january-last-year' },
  { label: 'first day of February last year', value: 'first-day-of-february-last-year' },
  { label: 'first day of March last year', value: 'first-day-of-march-last-year' },
  { label: 'first day of April last year', value: 'first-day-of-april-last-year' },
  { label: 'first day of May last year', value: 'first-day-of-may-last-year' },
  { label: 'first day of June last year', value: 'first-day-of-june-last-year' },
  { label: 'first day of July last year', value: 'first-day-of-july-last-year' },
  { label: 'first day of August last year', value: 'first-day-of-august-last-year' },
  { label: 'first day of September last year', value: 'first-day-of-september-last-year' },
  { label: 'first day of October last year', value: 'first-day-of-october-last-year' },
  { label: 'first day of November last year', value: 'first-day-of-november-last-year' },
  { label: 'first day of December last year', value: 'first-day-of-december-last-year' },
  { label: 'last day of January this year', value: 'last-day-of-january-this-year' },
  { label: 'last day of February this year', value: 'last-day-of-february-this-year' },
  { label: 'last day of March this year', value: 'last-day-of-march-this-year' },
  { label: 'last day of April this year', value: 'last-day-of-april-this-year' },
  { label: 'last day of May this year', value: 'last-day-of-may-this-year' },
  { label: 'last day of June this year', value: 'last-day-of-june-this-year' },
  { label: 'last day of July this year', value: 'last-day-of-july-this-year' },
  { label: 'last day of August this year', value: 'last-day-of-august-this-year' },
  { label: 'last day of September this year', value: 'last-day-of-september-this-year' },
  { label: 'last day of October this year', value: 'last-day-of-october-this-year' },
  { label: 'last day of November this year', value: 'last-day-of-november-this-year' },
  { label: 'last day of December this year', value: 'last-day-of-december-this-year' },
];